import SvgWaveLines from './SvgWaveLines';

export default SvgWaveLines;